import type { MutableState } from 'final-form'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setFieldData = <T>(args: any[], state: MutableState<T, Partial<T>>) => {
  const [name, data] = args
  const field = state.fields[name]
  if (field) {
    field.data = { ...field.data, ...data }
  }
}
